
export default {
    $validator: (value) => {
        if (typeof value !== 'string') {
            return false;
        }

        const v = value.trim();
        if (v.length < 11 || v.length > 13) {
            return false;
        }

        // כמו הודעת validation: 11–13 תווים, אותיות לטיניות, ספרות, רווחים (ומקף אם הודפס על המצבר)
        return /^[A-Za-z0-9\s\-]+$/.test(v);
    },
};
